import { render, staticRenderFns } from "./AlbumDetails.vue?vue&type=template&id=44ef4264&"
import script from "./AlbumDetails.vue?vue&type=script&lang=js&"
export * from "./AlbumDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports